let showError = (rule, params, name) => {
  let error = ''

  switch (rule) {
    case 'minLength':
      error = `${name} must be at last ${params[rule].min} character(s) long.`
      break
    case 'maxLength':
      error = `${name} must be maximuim ${params[rule].max} character(s) long.`
      break
    case 'between':
      error = `${name} must be between ${params[rule].min} and ${
        params[rule].max
      }.`
      break
    case 'hostName':
      error = `${name} is valid.`
      break
    case 'contains':
      error = `${name} must be one of the following values (${
        params[rule].value
      })`
      break
    case 'companyZipCode':
    case 'numeric':
    case 'country':
    case 'city':
    case 'integer':
    case 'phoneNumber':
      error = `${name} must be number.`
      break
    case 'decimal':
      error = `${name} must be decimal.`
      break
    case 'alpha':
    case 'name':
      error = `${name} must be alphabetical.`
      break
    case 'required':
      error = `${name} is required.`
      break
    case 'countyCode':
      error = `${name} must begin with 855.`
      break
    case 'email':
    case 'password':
    case 'confirmPassword':
      error = `${name} is not valid format.`
      break
    case 'ratePrice':
      error = `${name} is between (0, 1)`
      break

    case 'sameAsPassword':
      error = `The ${name} and password dose not match. `
  }
  return error
}

export function getMessageError(model, name) {
  if (typeof model.$model === 'undefined') return
  let error_ = ''
  let rules = Object.keys(model.$params)
  for (let i = 0; i < rules.length; i++) {
    let rule = rules[i]
    if (!model[rule]) {
      error_ = showError(rule, model.$params, name)
      break
    }
  }
  return error_
}

export function validate(field, form) {
  let _form = typeof form === 'undefined' ? this.$v.form : form
  if (!_form.hasOwnProperty(field)) return false
  _form[field].$touch()
  if (!!this.canSubmit) this.canSubmit(_form.$invalid)
  this.$forceUpdate()
}

export function invalid(field, form) {
  let _form = typeof form === 'undefined' ? this.$v.form : form
  if (!_form.hasOwnProperty(field)) return false
  return _form[field].$invalid
}

export function dirty(field, form) {
  let _form = typeof form === 'undefined' ? this.$v.form : form
  if (!_form.hasOwnProperty(field)) return false
  return _form[field].$dirty
}

export const phoneNumber = (value) => {
  const regex = /^[1-9]{1}\d{6,14}$/
  let match = regex.exec(value)
  if (!value) return true
  return !!match
}
